import { CommonModule } from '@angular/common';
import {Component, OnInit, ViewChild} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {InputTextModule} from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MessageService} from 'primeng/api';
import {Router, RouterLink} from '@angular/router';
import { firstValueFrom, forkJoin } from 'rxjs';
import { SafeResourcePipe } from 'lib-base';
import {ResultadosBusquedaComponent} from "../resultados-busqueda/resultados-busqueda.component";
import {CardModule} from "primeng/card";
import {SecDependenciaService} from "../../../services/sec-dependencia.service";
import {MultiSelectModule} from "primeng/multiselect";
import {VwSecDependencia} from "../../../shared/interfaces/seguridad";
import {AsidePublicComponent} from "../aside-public/aside-public.component";
import {SvgLoaderComponent} from "../../../../../../lib-base/src/lib/components";
import { MensajesEmergentesComponent } from '../../../components/global/mensajes-emergentes/mensajes-emergentes.component';

@Component({
  selector: 'app-consulta-tramites',
  standalone: true,
  imports: [CommonModule, FormsModule, TranslateModule, SafeResourcePipe,
    InputTextModule, ButtonModule, RouterLink, ResultadosBusquedaComponent, CardModule, MultiSelectModule, AsidePublicComponent, SvgLoaderComponent, MensajesEmergentesComponent],
  templateUrl: './consulta-tramites.component.html',
  styleUrl: './consulta-tramites.component.scss'
})
export class ConsultaTramitesComponent implements OnInit {
  text !: string | undefined;
  radicado !: string | undefined;
  dependenciasSelected !: VwSecDependencia[];
  dependencias:VwSecDependencia[] = [];

  translations: any = {};

  @ViewChild(ResultadosBusquedaComponent) resultadosBusquedaComponent!: ResultadosBusquedaComponent;

  constructor(private _ms: MessageService, private router: Router,
              private _ds: SecDependenciaService,
              private _translate: TranslateService) {
  }

  ngOnInit() {
    this.translate();
    this.getDependencias();
  }

  private async translate(): Promise<void> {
    this.translations = await firstValueFrom(forkJoin({
      completeCampos: this._translate.get('form.msg.complete-campos'),
      warnSummary: this._translate.get('form.msg.warn-summary'),
    }));
   }

  clear() {
    this.text = undefined;
  }

  buscar() {
    if (!this.text) {
      this._ms.add({ severity: 'warn', summary: this.translations.warnSummary, detail: this.translations.completeCampos });
      return;
    }
    this.resultadosBusquedaComponent.text = this.text;
    this.resultadosBusquedaComponent.dependencia = this.dependenciasSelected;
    this.resultadosBusquedaComponent.getTramitesBusqueda(this.text,
      this.dependenciasSelected?.map(f=>f.id));
  }


  buscarRadicado(){
    if (!this.radicado) {
      this._ms.add({ severity: 'warn', summary: this.translations.warnSummary, detail: this.translations.completeCampos });
      return;
    }
    this.router.navigateByUrl(`public/estado-tramite/${this.radicado}`);
  }

  getDependencias() {
    this._ds.getAllActivos().subscribe({
      next: value => this.dependencias = value
    })
  }

}
